import '.b3{cursor:pointer;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { TextInput } from '../text/TextInput'
import Column from '@app/components/layout/Column'
import { Text } from '../../typography/Text'
import { CardWrapper } from '@app/components/blocks/card/CardWrapper'
import { useRef } from 'react'

export type SearchSelectOption = {
  key: number
  value: string
}

export type SearchSelectProps = {
  label: string
  labelStyle?: Style
  displayLabelAsterisk?: boolean
  value: string
  setValue: (value: string) => void
  selectOption: (option: SearchSelectOption) => void
  abandonSelection: VoidFunction
  options: SearchSelectOption[]
  noResultsMessage?: { display: boolean; message: string }
}

export const SearchSelect = ({
  label,
  labelStyle,
  displayLabelAsterisk,
  value,
  options,
  noResultsMessage,
  setValue,
  selectOption,
  abandonSelection,
}: SearchSelectProps) => {
  const renderPopup = options.length > 0 || noResultsMessage?.display
  const ignoreBlurRef = useRef(false)

  const handleBlur = () => {
    if (ignoreBlurRef.current) {
      ignoreBlurRef.current = false
      return
    }
    abandonSelection()
  }

  return (
    <Column gap={0} alignItems="stretch" style={{ position: 'relative' }}>
      <TextInput
        text={value}
        setText={setValue}
        label={label}
        labelStyle={labelStyle}
        displayLabelAsterisk={displayLabelAsterisk}
        placeholder={label}
        onBlur={handleBlur}
      />
      {renderPopup && (
        <CardWrapper
          style={{
            position: 'absolute',
            top: 'calc(100% + 0.25rem)',
            width: '100%',
            zIndex: 1,
          }}
        >
          <Column alignItems="stretch">
            {options.map((option) => (
              <div className="b3"
                key={option.key}
                onMouseDown={(e) => {
                  e.preventDefault()
                  ignoreBlurRef.current = true
                  selectOption(option)
                }}
              >
                <Text.Medium>{option.value}</Text.Medium>
              </div>
            ))}
            {noResultsMessage?.display && (
              <Text.Medium color="var(--shades-blue-300)">
                {noResultsMessage.message}
              </Text.Medium>
            )}
          </Column>
        </CardWrapper>
      )}
    </Column>
  )
}
